<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
import {GAINROUTERSPOP, ROUTER_STOREAGE_REMOVE_END_ROUTER, ROUTER_STOREAGE_ROUTER_INFO} from "./vuex/routeStorage/type";

export default {
  name: 'App',
  data() {
    return {}

  },
  created() {
    window.localStorage.removeItem("ids")  //清理一下上次缓存
  }
}
</script>

<style>
html, body, #app {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* height: 1000px; */
}

*::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue